import { IPadding } from 'src/interfaces/global';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { addPaddingStyles, addTransition, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledSlider = styled.div<IPadding>`
	${(p) => css`
		position: relative;
		width: 100%;
		height: 40%;
		background-color: ${p.theme.colors.transparentBlack};
		border-radius: 5px;
		overflow: hidden;

		${addPaddingStyles(p)}

		@media (max-height: 800px) {
			height: 45%;
		}

		${mq(
			EMediaQuery.xl,
			css`
				max-height: 250px;
			`
		)}

		${mq(
			EMediaQuery.md,
			css`
				border-radius: 0px;
				height: 200px;
			`
		)}

		@media (max-height: 700px) {
			padding-bottom: 12px;
		}

		${mq(
			EMediaQuery.sm,
			css`
				min-height: 180px;
				margin-bottom: 12px;
			`
		)}
	`}
`;

export const StyledInformationContainer = styled.div`
	position: relative;
	width: 100%;
`;

export const StyledImageContainer = styled.div`
	${(p) => css`
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;

		${mq(EMediaQuery.md, `bottom: 40px;`)}
		${mq(EMediaQuery.sm, `bottom: 70px;`)}
	`}
`;

export const StyledImage = styled.div<{ isVisible?: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;

	${addTransition()}

	${(p) =>
		p.isVisible
			? css`
					opacity: 1;
					//transform: translateY(0);
			  `
			: css`
					opacity: 0;
					//transform: translate(100%);
			  `}
`;
